import { render, staticRenderFns } from "./rebateSetting.vue?vue&type=template&id=bd7a1ece&scoped=true"
import script from "./rebateSetting.vue?vue&type=script&lang=js"
export * from "./rebateSetting.vue?vue&type=script&lang=js"
import style0 from "./rebateSetting.vue?vue&type=style&index=0&id=bd7a1ece&prod&scoped=true&lang=css"
import style1 from "./rebateSetting.vue?vue&type=style&index=1&id=bd7a1ece&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7a1ece",
  null
  
)

export default component.exports